import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Kalorama Medical - Durable Medical Equipment',
  description = 'Quality durable medical equipment including wheelchairs, walkers, hospital beds, bath safety equipment and more. Expert guidance and insurance accepted.',
  keywords = 'medical equipment, durable medical equipment, wheelchairs, walkers, rollators, hospital beds, bath safety, mobility aids',
  canonicalUrl = 'https://kaloramamedical.com'
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
    </Helmet>
  );
};

export default SEO;
